import React from "react";
import {
  createStyles,
  ListItemIcon,
  makeStyles,
  Theme
} from "@material-ui/core";
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    icon: {
      minWidth: theme.spacing(0),
      paddingRight: "10px"
    },
    centered: {
      alignItems: "center"
    }
  })
);

export const DenseIcon = (props) => {
  const classes = useStyles();
  const {children, centered, ...other} = props;

  return (
    <ListItemIcon {...other} className={clsx(classes.icon, {
      [classes.centered]: centered
    })}>
      {children}
    </ListItemIcon>
  );
};